import { IonContent, IonPage, IonButton, IonInput } from "@ionic/react";
import { Icon, LockIcon, UserIcon } from "evergreen-ui";
import { useContext, useState, useEffect } from "react";
import { globalContext } from "../../global/Store";
import { Lookup, User, Development } from "../../global/Types";
import {
  LogoGroup,
  LoginForm,
  Logo,
  UsernameGroupColumn,
  UsernameGroup,
  PasswordGroup,
  UsernameGroupColumnFiller,
  ButtonOverlay,
  BtnLoginText,
  InfoText,
  InfoText2
} from "./setPasswordStyle";
import { dataRepoContext } from "../../data-repo/DataRepo";

export const SetPassword = () => {

  const { globalState, dispatch, globalFunctions } = useContext(globalContext);
  const { globalDataRepo } = useContext(dataRepoContext);

  const emailLinkId = window.location.pathname.split("/").pop();
  const [username, setUsername] = useState<string | null | undefined>("");
  const [password, setPassword] = useState<string | null | undefined>("");
  const [repeatPassword, setRepeatPassword] = useState<string | null | undefined>("");
  const [passwordSetSuccess, setPasswordSetSuccess] = useState(-1);


  useEffect(() => {
    console.log("Started");
    if (emailLinkId === 'set-password') {
      globalFunctions.Reroute("/login");
    }
  }, [])

  const validateForm = () => {

    var _validation = { status: false, message: '' }

    if (!!username && /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(username.trim())) {
      _validation.status = true;
      _validation.message = '';
    } else {
      _validation.status = false;
      _validation.message = 'Email is not valid';
    }

    if (_validation.status === true) {

      if (!!password && /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{12,}$/.test(password.trim())) {
        if (password === repeatPassword) {
          _validation.status = true;
          _validation.message = '';
        } else {
          _validation.status = false;
          _validation.message = 'Passwords do not match';
        }
      } else {
        _validation.status = false;
        _validation.message = 'Password must be at least 12 characters and contain at least one: upper case letter, lower case letter, number and special character';
      }
    }

    return _validation;

  }

  const handleSetPassword = () => {

    var _validationResult = validateForm();


    if(emailLinkId === undefined) {
      setPasswordSetSuccess(0);
    }

    if (_validationResult.status === true && !!emailLinkId && !!username && !!password) {

      globalDataRepo.ResetPassword(emailLinkId.trim(), username.trim(), password.trim()).then(
        function (response: any) {
          console.log("password set");
          console.log(response);
          setPasswordSetSuccess(response.status);
        },
        function (error: any) {
          setPasswordSetSuccess(0);
        }
      );

    }

    if (_validationResult.status === false) {
      globalFunctions.HandleToast({
        header: "Error",
        id: "Set-Password-Error",
        description: _validationResult.message,
        type: "danger",
        error: '',
      });
    }
  };

  const handleKeyDown = (e: any) => {
    if (e.key === 'Enter') {
      passwordSetSuccess == 1 ? handleLoginRedirect() : handleSetPassword();
    }
  }


  const handleLoginRedirect = () => {
    globalFunctions.Reroute("/login");
  }

  const handleForgotPasswordRedirect = () => {
    globalFunctions.Reroute("/forgot-password");
  }

  

  return (
    <IonPage>
      <IonContent style={{ "--background": "white" }}>
        <LogoGroup style={{ marginTop: "120px", width: "100%" }}>
        <Logo src={"../../assets/encompassicon/Encompass.png"}></Logo>
        </LogoGroup>
        <LoginForm>

          {passwordSetSuccess === -1 ?
            <>
              <UsernameGroupColumn>
                <UsernameGroup>
                  <Icon
                    icon={UserIcon}
                    size={20}
                    style={{
                      color: "white",
                      marginTop: "18px",
                      marginLeft: "10px",
                    }}
                  />
                  <IonInput
                    type="text"
                    className="login-input"
                    placeholder="Email"
                    style={{
                      color: "#ff0000",
                      marginLeft: "10px",
                      boxShadow: "none",
                    }}
                    value={username}
                    onIonChange={(event) => setUsername(event.detail.value)}
                    onKeyDown={handleKeyDown}
                  //   autocomplete="off"
                  //   onfocusout="this.removeAttribute('readonly');"
                  //   onfocus="this.setAttribute('readonly','readonly');"
                  ></IonInput>
                  
                </UsernameGroup>

                
                
                <PasswordGroup>
                  <Icon
                    icon={LockIcon}
                    size={20}
                    style={{
                      color: "white",
                      marginTop: "18px",
                      marginLeft: "10px",
                    }}
                  />
                  <IonInput
                    type="text"
                    className="login-input"
                    placeholder="Password"
                    style={{
                      color: "#980053",
                      marginLeft: "10px",
                      textSecurity: " disc",
                      WebkitTextSecurity: "disc",
                      boxShadow: "none",
                    }}
                    value={password}
                    onIonChange={(event) => setPassword(event.detail.value)}
                    onKeyDown={handleKeyDown}
                  //   autocomplete="off" //readonly
                  //   onfocusout="this.removeAttribute('readonly');"
                  //   onfocus="this.setAttribute('readonly','readonly');"
                  ></IonInput>
                </PasswordGroup>
                <PasswordGroup>
                  <Icon
                    icon={LockIcon}
                    size={20}
                    style={{
                      color: "white",
                      marginTop: "18px",
                      marginLeft: "10px",
                    }}
                  />
                  <IonInput
                    type="text"
                    className="login-input"
                    placeholder="Repeat password"
                    style={{
                      color: "#980053",
                      marginLeft: "10px",
                      textSecurity: " disc",
                      WebkitTextSecurity: "disc",
                      boxShadow: "none",
                    }}
                    value={repeatPassword}
                    onIonChange={(event) => setRepeatPassword(event.detail.value)}
                    onKeyDown={handleKeyDown}
                  //   autocomplete="off" //readonly
                  //   onfocusout="this.removeAttribute('readonly');"
                  //   onfocus="this.setAttribute('readonly','readonly');"
                  ></IonInput>
                </PasswordGroup>
                <InfoText>
                Password must be at least 12 characters and contain at least one: upper case letter, lower case letter, number and special character
                </InfoText>
              </UsernameGroupColumn>
              <UsernameGroupColumnFiller></UsernameGroupColumnFiller>
              <IonButton className="jm-ion-btn" onClick={handleSetPassword}>
                <ButtonOverlay>
                  <BtnLoginText>Set Password</BtnLoginText>
                </ButtonOverlay>
              </IonButton></> : null}

          {passwordSetSuccess === 1 ?

            <>
              <UsernameGroupColumnFiller>
                <div style={{ textAlign: "center" }}>
                  <p>Password set successfully. <br />Please proceed to login.</p>
                </div>
              </UsernameGroupColumnFiller>
              <IonButton className="jm-ion-btn" onClick={handleLoginRedirect}>
                <ButtonOverlay>
                  <BtnLoginText>Login</BtnLoginText>
                </ButtonOverlay>
              </IonButton></> : null}
          {passwordSetSuccess === 0 ?
            <>
            <UsernameGroupColumnFiller>
              <div style={{ textAlign: "center" }}>
                <p>Password set failed.</p>
                
              </div>
              <InfoText2>
              <p>If the email to set your password was sent more than 48 hours ago, it will have expired.</p>
                <p>Please request a new password reset.</p>
                </InfoText2>
            </UsernameGroupColumnFiller>
            
            <IonButton className="jm-ion-btn" onClick={handleForgotPasswordRedirect}>
                <ButtonOverlay>
                  <BtnLoginText>Request Password reset</BtnLoginText>
                </ButtonOverlay>
              </IonButton>
            </>

            : null}
        </LoginForm>

      </IonContent>
    </IonPage>
  );
};
